import React, { useState } from "react"
import { SubNav } from "./";
import { SessionStorage } from "../../util";
import { Common } from "../../helper";

const SubNavContainer = (props) => {
  const [selectedClass, setSelectedClass] = useState("");
  const { ClassArray, handleNavSelect, setMyClasses, isCollapsed, setIsCollapsed } = props;
  
  const selectedEkey=SessionStorage.getItem(Common.EKey)
  const selectedClassIdFromSession=SessionStorage.getItem(Common.EKey)?.split("-").slice(0, 2).join("-");
    
  return (
    <>
      {ClassArray.map((Class, i) => {
        return (
          <SubNav key={`C-${i}`} {...Class} i={`C-${i}`} selectedClass = {selectedEkey ? (`C-${i}`===selectedClassIdFromSession) : (`C-${i}` === selectedClass ? true : false)} setSelectedClass={setSelectedClass} handleNavSelect={handleNavSelect} setMyClasses={setMyClasses} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        )
      })}
    </>
  )
}

export { SubNavContainer };
